<template>
  <el-dialog
    :model-value="modelValue"
    :title="title"
    width="720px"
    :close-on-click-modal="false"
    @update:model-value="close"
    @open="reason = ''"
  >
    <slot></slot>
    <div class="reason-block">
      <label class="form-label" for="delete-reason">{{ reasonLabel }}</label>
      <el-input
        id="delete-reason"
        v-model="reason"
        type="textarea"
        :rows="3"
        :maxlength="DELETE_REASON_MAX"
        show-word-limit
        :placeholder="`Не менее ${DELETE_REASON_MIN} символов`"
      />
    </div>
    <template #footer>
      <el-button @click="close" :disabled="loading">Отмена</el-button>
      <el-button :type="variant === 'restore' ? 'primary' : 'danger'" :loading="loading" :disabled="!valid" @click="confirm">
        {{ confirmText }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from "vue";
import { DELETE_REASON_MAX, DELETE_REASON_MIN } from "@/types/deleteRequest";

/** Единый диалог подтверждения удаления/восстановления с обязательной причиной; превью строк — в слоте. */
export default defineComponent({
  name: "DeleteReasonDialog",
  props: {
    modelValue: { type: Boolean, required: true },
    title: { type: String, default: "Подтвердите удаление" },
    confirmText: { type: String, default: "Удалить" },
    reasonLabel: { type: String, default: "Причина удаления" },
    variant: { type: String as () => "delete" | "restore", default: "delete" },
    loading: { type: Boolean, default: false },
  },
  emits: ["update:modelValue", "confirm"],
  setup(props, { emit }) {
    const reason = ref("");
    const valid = computed(() => {
      const trimmed = reason.value.trim();
      return trimmed.length >= DELETE_REASON_MIN && trimmed.length <= DELETE_REASON_MAX;
    });
    const close = () => emit("update:modelValue", false);
    const confirm = () => {
      if (valid.value) {
        emit("confirm", reason.value.trim());
      }
    };
    return { reason, valid, close, confirm, DELETE_REASON_MIN, DELETE_REASON_MAX };
  },
});
</script>

<style scoped>
.reason-block {
  margin-top: 16px;
}
</style>
